module.exports = __webpack_public_path__ + "img/fondo-banner-principal.25475640.svg";